import { render, staticRenderFns } from "./ProjectListTab.vue?vue&type=template&id=275acafd&scoped=true"
import script from "./ProjectListTab.vue?vue&type=script&lang=js"
export * from "./ProjectListTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectListTab.vue?vue&type=style&index=0&id=275acafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275acafd",
  null
  
)

export default component.exports